import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LoginForm } from './components/Auth/LoginForm';
import { RegisterForm } from './components/Auth/RegisterForm';
import { ResetPasswordForm } from './components/Auth/ResetPasswordForm';
import { ForgotPasswordForm } from './components/Auth/ForgotPasswordForm';
import { Dashboard } from './components/Dashboard/Dashboard';
import LandingPage from './pages/LandingPage';
import RegistrationSuccess from "./components/Auth/RegistrationSuccess";
import { PublicRoute, PrivateRoute } from './components/Routes/ProtectedRoutes';
import { NotificationProvider } from './contexts/NotificationContext';
import ContactPage from './pages/ContactPage';
import TermsOfUse from './pages/Legal/TermsOfUse';
import TermsOfSale from './pages/Legal/TermsOfSale';
import PrivacyPolicy from "./pages/Legal/PrivacyPolicy";
import CookiePolicy from './pages/Legal/CookiePolicy';
import EmailVerificationSuccess from "./components/Auth/EmailVerificationSuccess";
import { initGA, trackPageView } from './utils/analytics';
import EmailVerification from "./components/Emailverification";
import AppRedirect from './pages/AppRedirect';

// Composant pour tracker les changements de page
const AnalyticsTracker = () => {
    const location = useLocation();
    const [gaReady, setGaReady] = useState(false);

    // Initialiser GA une seule fois
    useEffect(() => {
        const initializeGA = async () => {
            await initGA();
            setGaReady(true);
        };

        initializeGA();
    }, []);

    // Tracker les changements de page une fois GA prêt
    useEffect(() => {
        if (gaReady) {
            trackPageView(location.pathname + location.search);
        }
    }, [location, gaReady]);

    return null;
};

export const App = () => {
    return (
        <NotificationProvider>
            <Router>
                <AnalyticsTracker />
                <Routes>
                    {/* Public routes - only accessible when not logged in */}
                    <Route
                        path="/"
                        element={
                            <PublicRoute>
                                <LandingPage />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/cgu"
                        element={
                            <PublicRoute>
                                <TermsOfUse />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/cgv"
                        element={
                            <PublicRoute>
                                <TermsOfSale />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/privacy-policy"
                        element={
                            <PublicRoute>
                                <PrivacyPolicy />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/cookie-policy"
                        element={
                            <PublicRoute>
                                <CookiePolicy />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/contact"
                        element={
                            <PublicRoute>
                                <ContactPage />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/login"
                        element={
                            <PublicRoute>
                                <LoginForm />
                            </PublicRoute>
                        }
                    />
                    <Route path="/verify-email/:token"
                           element={
                               <PublicRoute>
                                   <EmailVerificationSuccess />
                               </PublicRoute>
                           }
                    />

                    <Route
                        path="/register"
                        element={
                            <PublicRoute allowRegistration={false}>
                                <RegisterForm />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/reset-password"
                        element={
                            <PublicRoute>
                                <ResetPasswordForm />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/forget-password"
                        element={
                            <PublicRoute>
                                <ForgotPasswordForm />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/reset-password"
                        element={
                            <PublicRoute>
                                <ResetPasswordForm />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/registration-success"
                        element={
                            <PublicRoute>
                                <RegistrationSuccess />
                            </PublicRoute>
                        }
                    />
                    {/* Route pour la vérification d'email */}
                    <Route path="/mobile-verify-email/:token"
                           element={
                            <PublicRoute>
                                <EmailVerification />
                            </PublicRoute>
                        }
                    />
                    {/* Lien public : redirige vers App Store / Google Play (accessible connecté ou non) */}
                    <Route path="/app" element={<AppRedirect />} />
                    {/* Private routes - only accessible when logged in */}
                    <Route
                        path="/dashboard/*"
                        element={
                            <PrivateRoute>
                                <Dashboard />
                            </PrivateRoute>
                        }
                    />

                    {/* Redirect any unmatched routes */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Router>
        </NotificationProvider>
    );
};

export default App;